export default "__VITE_ASSET__c2n8wPgn__"